import { API_BASE_URL } from 'src/env';
import { ApiReturnType } from 'src/interfaces/api/api';
import { toQueryParamsString } from '../../utils/ApiUtils';

export default {
  getEmployeeEvents: (employeeId: string, page: number, limit: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/gaming/feed/employees/${employeeId}${toQueryParamsString({ page, limit })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
};
